import {
  SCHEDULE_MAIL_PARAMETER_KIND_LABELS,
  SCHEDULE_MAIL_PARAMETER_KIND_ORDER,
  type ScheduleMailParameterDefinition,
} from "./scheduleMailTemplate";

// 各パラメータが送信時にどんな値に置き換わるかの参照リスト（折りたたみ）
export function MailParameterReference({
  parameters,
}: {
  parameters: ScheduleMailParameterDefinition[];
}) {
  return (
    <details className="mt-2 rounded-md border border-[var(--color-border-default)] bg-[var(--color-bg-subtle-gray)] p-2">
      <summary className="cursor-pointer text-[var(--color-text-secondary)] text-xs">
        パラメータの説明（送信時に置き換わる値）
      </summary>
      <div className="mt-2 flex flex-col gap-3">
        {SCHEDULE_MAIL_PARAMETER_KIND_ORDER.map((kind) => {
          const params = parameters.filter((p) => p.kind === kind);
          if (params.length === 0) return null;
          return (
            <ParameterReferenceGroup
              key={kind}
              title={SCHEDULE_MAIL_PARAMETER_KIND_LABELS[kind]}
              params={params}
            />
          );
        })}
      </div>
    </details>
  );
}

function ParameterReferenceGroup({
  title,
  params,
}: {
  title: string;
  params: ScheduleMailParameterDefinition[];
}) {
  return (
    <div>
      <p className="mb-1 font-bold text-[10px] text-[var(--color-text-secondary)]">
        {title}
      </p>
      <ul className="flex flex-col gap-1.5">
        {params.map((p) => (
          <li key={p.name} className="text-xs leading-relaxed">
            <span className="mail-parameter-chip">@{p.name}</span>
            <span className="ml-2 text-[var(--color-text-primary)]">
              {p.label}
            </span>
            <span className="ml-1 text-[var(--color-text-secondary)]">
              — {p.example}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
